export default "__VITE_ASSET__cf0b5b14__"